import React, {useState} from "react";
import {Button, Form, Modal} from "semantic-ui-react";
import {CloneEntityProps} from "./types";
import {Field} from "./common/Field";
import {assocPath, path} from "ramda"
export function CloneEntity<F extends CloneEntityProps>({
                                                         fields,
                                                         entity,
                                                         entityName,
                                                         options,
                                                         onEntityCloned,
                                                         cloneEntity,
                                                         customIconProps,
                                                         originalEntity
                                                          }: CloneEntityProps) {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState<Record<string, any>>(Object.fromEntries(
      Object.keys(entity).map(key => [key, path(key.split("."), entity)])
  ));
  options = {
    buttonText: `Clone`,
    modalTitle: `Edit ${entityName}`,
    ...options};

  const handleClone = () => {
      cloneEntity(formData, originalEntity)
      .then((data: any) => {
        onEntityCloned && onEntityCloned(data);
      });

    setOpen(false);
  }

  return <>
    <Button floated={"right"} size="small" icon={customIconProps ?? "edit"} onClick={() => setOpen(true)}/>

      <Modal
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={open}
      >
        <Modal.Header>{options.modalTitle}</Modal.Header>
        <Modal.Content>
          <Form
              onSubmit={e => {
            e.preventDefault();
          }}>
          {Object.values(fields).map(fieldDef =>
            <Field fieldDef={fieldDef} entityName={entityName}
                   key={fieldDef.key}
                   value={path(fieldDef.key.split("."), formData)}
                   onChange={ value => {
                     setFormData( f => assocPath(fieldDef.key.split("."), value, f))
                   }}
            />
          )}</Form>

        </Modal.Content>
        <Modal.Actions>
          <Button color='black' onClick={() => setOpen(false)}>
            Close
          </Button>
          <Button
            primary
            type='submit'
            content={options.buttonText}
            labelPosition='right'
            icon='checkmark'
            onClick={() => handleClone()}
          />

        </Modal.Actions>

      </Modal>
  </>
}